$(document).ready(function(){
  let clickedEmptyPin = false;
  var pincode_value = localStorage.getItem('storage_pincode');
  var pincode_length = pincode_value && pincode_value !== 'null' ? pincode_value.length : 0;
  $('.pincode_value').val(pincode_value);
  $(".chk_pincode").click(function() {
    if($(this).text() == 'CHECK'){
        var pincode_value = $(".pincode_value").val();
        if (pincode_value != '' && pincode_value.length == 6){
            //localStorage.setItem('pincode', pincode_value);
           chkPincode(pincode_value);
        }
        else{
            $('.pincode_btn').css('display','flex');
            //$(".pdpAddBtn").hide();
           // $('.chk_pinBtn').show();
           // $('.sticky_dummy-button').show();
           // $('.sticky-button').hide();
            $('.show_message').show().fadeIn(500);
            $('.show_message').text('Enter 6 digit pin code to check if we deliver to you');
            $('html, body').animate({
            scrollTop: $('.show_message').offset().top - 245
            }, 500);
        }
    }
    else{
        localStorage.setItem('pincode', '');
        //$('.chk_pinBtn').show();
        //$('.sticky_dummy-button').show();
        $(this).text('CHECK');
        $(".pincode_value").removeAttr('readonly');
        $('.show_message').text('').hide();
        //$(".pdpAddBtn").hide();
        //$('.sticky-button').hide();
        $(".pdpAddBtn").prop("disabled",true);
    }
  });
  function chkPincode(pincode_value) {
    $.ajax({
        type: "GET",
        url: "https://cdn.shopify.com/s/files/1/0592/0266/6671/files/Pincode_Services_by_Zippee.csv?v=1734592804",
        data: { 'pincode': pincode_value },
        dataType: "text",
        success: function(data) {
            var lines = data.split('\n');
            var pincodeIndex = -1;

            // Find the index of the pincode in the file
            for (var i = 0; i < lines.length; i++) {
                if (lines[i].includes(pincode_value)) {
                    pincodeIndex = i;
                    break;
                }
            }
            if (pincodeIndex !== -1) {
                var columns = lines[pincodeIndex].split(',');
                var message = columns[1];
               if (pincode_value == columns[0]) {
                //$('.chk_pinBtn').hide();
                //$(".pdpAddBtn").show();
                //$('.sticky_dummy-button').hide();
               // $('.sticky-button').show();
                localStorage.setItem('storage_pincode', pincode_value);
                $(".pincode_value").attr('readonly', true);
                $(".chk_pincode").text('CHANGE');
                //setIntoCart(pincode_value);
              // Check if pincode_value starts with '4'
              if (pincode_value.startsWith('40')) {
                  $('.show_message').show();
                  $('.show_message').text('Your order will be delivered within 3-4 working days!');
              } 
              else {
                  $('.show_message').show();
                  $('.show_message').text('Your order will be delivered today if you place it before 3 PM!');
              }
             
             }
               else {
            
                localStorage.setItem('storage_pincode', pincode_value);
                $(".pincode_value").attr('readonly', true);
                $(".chk_pincode").text('CHANGE');
                $('.show_message').text('Your order will be delivered within 3-4 working days!');
                $('.show_message').show();
                
              }
           } 
            else {
                localStorage.setItem('storage_pincode', pincode_value);
                $(".pincode_value").attr('readonly', true);
                $(".chk_pincode").text('CHANGE');
                $('.show_message').text('Your order will be delivered within 3-4 working days!');
                $('.show_message').show();
                
            }
        },
        error: function(xhr, status, error) {
            console.log(error); // Log error for debugging
        }
    });
}
  function setIntoCart(pincode_value) {
              var data = {};
              data['pincode'] = pincode_value;
              $.ajax({
                  type: 'POST',
                  url: "/cart/update.js",
                  data: { attributes: data },
                  dataType: "json",
                  async: false,
                  cache: false,
                  success: function(response) {
                  }
              });
          }
  
  // $('.chk_pinBtn').click(function(event) {
  //   var pincode_value =  $('.pincode_value').val();
  //   if(pincode_value != '' && pincode_value.length == 6){
  //     $('.show_message').text('').hide();
  //     $('.pdpAddBtn').show().fadeIn(400);
  //     $('.chk_pinBtn').hide().fadeOut(400);
  //     $('.sticky_dummy-button').hide().fadeOut(400);
  //     $('.sticky-button').show().fadeIn(400);
  //     // clickedEmptyPin = true;
  //     $(".chk_pincode").trigger('click');
  //     chkPincode(pincode_value);
  //   }
  //   else{
  //     $('.pdpAddBtn').hide();
  //     $('.chk_pinBtn').show();
  //     $('.sticky_dummy-button').show().fadeOut(400);
  //     $('.sticky-button').hide().fadeIn(400);
  //     $('.show_message').text('Enter 6 digit pin code to check if we deliver to you').show().fadeIn(500);
  //     $('html, body').animate({
  //       scrollTop: $('.show_message').offset().top - 245
  //     }, 500);
  //   }
  //   });
  
   if (pincode_value != '' && pincode_length > 5){
    chkPincode(pincode_value);
    // $('.chk_pinBtn').hide();
    // $('.pdpAddBtn').show();
  }
  //  else{
  //   $('.chk_pinBtn').show();
  //   $('.pdpAddBtn').hide();
  // }

  
  
});